import { render, staticRenderFns } from "./Confirm_promotion_Monthlymobile.vue?vue&type=template&id=2fdd0a1a&"
import script from "./Confirm_promotion_Monthlymobile.vue?vue&type=script&lang=js&"
export * from "./Confirm_promotion_Monthlymobile.vue?vue&type=script&lang=js&"
import style0 from "./Confirm_promotion_Monthlymobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports